export default {
  // ApiServer: 'http://3.35.236.61:8080/api', // kpnp-on
  // ApiServer: 'https://api.kpnp-on.com/api', // kpnp-on
  // LambdaServer: 'https://xipzzqgsjd.execute-api.ap-northeast-2.amazonaws.com/api', // kpnp-on
  // AuthServer: 'https://api.kpnp-on.com/api', // kpnp-on
  // ApiServer: "https://api.kpnp-on.com/api", // kpnp-on
  // ApiServer: "http://52.79.182.104:8080/api", // test
  // ApiServer: 'http://localhost:8080/api', // local
  // authLambda: 'https://rz2vevoydl.execute-api.ap-northeast-2.amazonaws.com/api',
  // infoLambda: 'https://rz2vevoydl.execute-api.ap-northeast-2.amazonaws.com/api',
  // competitionLambda: 'https://o99mv7pao9.execute-api.ap-northeast-2.amazonaws.com/api',
  // scoreLambda: 'https://4ree3auky6.execute-api.ap-northeast-2.amazonaws.com/api',

  authLambda: 'https://5k1d5lgllg.execute-api.ap-northeast-2.amazonaws.com/api',
  infoLambda: 'https://5k1d5lgllg.execute-api.ap-northeast-2.amazonaws.com/api',
  competitionLambda: 'https://2pmsey08wi.execute-api.ap-northeast-2.amazonaws.com/api',
  scoreLambda: 'https://g4x416awc0.execute-api.ap-northeast-2.amazonaws.com/api',

};
